export const INVESTMENT_AMOUNT_CONSTANTS = {
    MIN_AMOUNT: 10,
    MAX_AMOUNT: 500,
    STEP: 10,
};
export const fullyInvestedErrorMessage = 'investing_in_this_loan_impossible';
export const tooBigAmountErrorMessage = 'investment_amount_too_big';
